module.exports = __webpack_public_path__ + "media/images/policy-bg-320-3606fbe540001d759f5ed3bacd177d51.png";